import { debounce, put, call } from 'redux-saga/effects';

import { Creators, Types } from 'src/store/redux/scans/actions';
import scansApi from 'src/services/api/scans';

export function* list(action: any) {
  try {
    const response = yield call(scansApi.list, action.filters);
    yield put(Creators.scansListRequestSuccess(response.data));
  } catch (e) {
    let error = e.response;
    yield put(Creators.scansListRequestError(error));
  }
}

export function* watchList() {
  yield debounce(6e2, Types.SCANS_LIST_REQUEST, list);
}

export default watchList;
